import React, {useState} from 'react';
import {Message} from '@aperza/ui';
import FormFieldControl from './FormFieldControl';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import style from './FormField.module.scss';

const FormField = props => {

  let {
    controlType,
    controlId,
    readOnly = false,
    options,
    fieldNameId,
    fieldName,
    showLabel = false,
    remarkId,
    placeholderId,
    invalid,
    errorId,
    errorIdValues = {},
    value,
    loading,
    onBlur,
    onChange,
    layout,
  } = props;

  const { t } = useTranslation();
  let [internalType, setInternalType] = useState(controlType?controlType:options?'select':'input');

  const _onBlur = (fieldName, value, inputValue) => {
    if (onBlur) {
      onBlur(fieldName, value, inputValue);
    }
  };

  const _onChange = (fieldName, value, inputValue) => {
    if (onChange) {
      onChange(fieldName, value, inputValue);
    }
  };

  const createFormField = () => {
    return (
      <Form.Group className={style.formGroup} controlId={controlId}>
        {fieldNameId && !readOnly && showLabel &&
        <Form.Label>
          <Message messageId={fieldNameId}/>
          {remarkId &&
          <Message messageId={remarkId}/>
          }
        </Form.Label>
        }
        <FormFieldControl fieldNameId={fieldNameId}
                          fieldName={fieldName}
                          placeholderId={placeholderId}
                          controlType={internalType}
                          options={options}
                          readOnly={readOnly}
                          invalid={invalid}
                          value={value}
                          loading={loading}
                          onBlur={_onBlur}
                          onChange={_onChange}
        />
        {invalid && errorId && !readOnly &&
        <Form.Control.Feedback type="invalid" style={{display: 'block'}}>
          <Message messageId={errorId} values={{
            field: fieldNameId?t(fieldNameId):fieldName,
            ...errorIdValues,
          }}/>
        </Form.Control.Feedback>
        }
      </Form.Group>
    )
  };

  const createFormFieldHorizontal = () => {
    return (
      <Form.Group as={Row} className={style.formGroup} controlId={controlId}>
        {fieldNameId &&
        <Form.Label sm={2}>
          <Message messageId={fieldNameId}/>
          {remarkId &&
          <Message messageId={remarkId}/>
          }
        </Form.Label>
        }
        <Col sm={10}>
          <FormFieldControl fieldNameId={fieldNameId}
                            fieldName={fieldName}
                            placeholderId={placeholderId}
                            controlType={internalType}
                            options={options}
                            readOnly={readOnly}
                            invalid={invalid}
                            value={value}
                            loading={loading}
                            onBlur={_onBlur}
                            onChange={_onChange}
          />
          {invalid && errorId && !readOnly &&
          <Form.Control.Feedback type="invalid" style={{display: 'block'}}>
            <Message messageId={errorId} values={{
              field: fieldNameId?t(fieldNameId):fieldName,
              ...errorIdValues,
            }}/>
          </Form.Control.Feedback>
          }
        </Col>
      </Form.Group>
    )
  };

  return (layout==='horizontal'?createFormFieldHorizontal():createFormField())

};

FormField.propTypes = {
  controlId: PropTypes.string,
  controlType: PropTypes.string,
  fieldName: PropTypes.string,
  fieldNameId: PropTypes.string,
  showLabel: PropTypes.bool,
  placeholderId: PropTypes.string,
  remarkId: PropTypes.string,
  errorId: PropTypes.string,
  invalid: PropTypes.bool,
  constraint: PropTypes.any,
  options: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  value: PropTypes.any,
  loading: PropTypes.bool,
  layout: PropTypes.string,
};

export default FormField;
